import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoubleCheckmark2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDoubleCheckmark2"><Path d="M1.5 14.8125L7.44445 19.5L18.5 4.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.4445 19.5L22.5 4.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDoubleCheckmark2;
